import React from 'react';
import { Field } from 'redux-form';
import { useSelector } from 'react-redux';
import ChargerDetailsImages from '../ChargerDetailsImages';
import { getCurrentChargerCustomerId } from '../../selectors';
import { getCustomerId } from '../../../Login/selectors';

function ImageLoader(props) {
  const currentChargerCustomerId = useSelector(getCurrentChargerCustomerId);
  const customerId = useSelector(getCustomerId);
  const pictureKeys = currentChargerCustomerId === customerId
    ? props.input.value
    : props.input.value.map((pictureKey) => `${pictureKey}?customerId=${currentChargerCustomerId}`);

  return (
    <ChargerDetailsImages
      pictureKeys={pictureKeys}
      onChange={props.input.onChange}
      label={props.label}
      subLabel={props.subLabel}
      readOnly={props.readOnly}
    />
  );
}

export const renderImageLoader = (field) => {
  const props = {
    label: field.floatingLabelText,
    subLabel: field.subLabel,
    readOnly: field.readOnly,
  };

  return (
    <Field
      key={field.name}
      name={field.name}
      component={ImageLoader}
      {...props}
    />
  );
};
